/*
  jQuery 4 removed these helpers. Shopify's api.jquery.js (Shopify-hosted, can't be edited)
  and the bundled plugins still call them, so restore them here instead of loading jQuery Migrate.
  Load right after jQuery.
*/
(function ($) {
  var class2type = {};
  "Boolean Number String Function Array Date RegExp Object Error Symbol".split(" ").forEach(function (name) {
    class2type["[object " + name + "]"] = name.toLowerCase();
  });

  $.isArray = Array.isArray;
  $.isFunction = function (obj) { return typeof obj === "function"; };
  $.trim = function (text) { return text == null ? "" : String(text).trim(); };
  $.parseJSON = JSON.parse;
  $.now = Date.now;
  $.unique = $.uniqueSort;
  $.isNumeric = function (obj) {
    var type = typeof obj;
    return (type === "number" || type === "string") && !isNaN(obj - parseFloat(obj));
  };
  $.camelCase = function (text) {
    return text.replace(/-([a-z])/g, function (_, letter) { return letter.toUpperCase(); });
  };
  $.type = function (obj) {
    if (obj == null) return obj + "";
    return typeof obj === "object" || typeof obj === "function"
      ? class2type[Object.prototype.toString.call(obj)] || "object"
      : typeof obj;
  };
})(jQuery);
